import Vue from 'vue';
import VueRouter from 'vue-router';
import Account from '@/views/Account';
import AccountTripHistory from '@/views/account/TripHistory';
import AccountPerks from '@/views/account/Perks';
import AccountProfile from '@/views/account/Profile';
import AccountProfileSettings from '@/views/account/profile/Settings';
import AccountProfileFitAndStyle from '@/views/account/profile/FitAndStyle';
import AccountProfileBilling from '@/views/account/profile/Billing';

import Wizard from '@/views/trip/Wizard';

import Auth from '@/views/Auth';
import AuthForgot from '@/views/auth/ForgotPassword';
import AuthRegister from '@/views/auth/Register';
import AuthReset from '@/views/auth/Reset';
import AuthOauth from '@/views/auth/Oauth';
import AuthVerify from '@/views/auth/Verify';

import Admin from '@/views/Admin';
import AdminDashboard from '@/views/admin/Dashboard';
import AdminTrip from '@/views/admin/Trip';
import AdminInventory from '@/views/admin/Inventory';
import AdminUsers from '@/views/admin/Users';

Vue.use(VueRouter)

const routes = [
  {
    path: '/account',
    name: 'account',
    component: Account,
    children: [{
      path: 'trips',
      name: 'account-trips',
      component: AccountTripHistory
    },
    {
      path: 'perks',
      name: 'account-perks',
      component: AccountPerks,
    },
    {
      path: 'profile',
      name: 'account-profile',
      component: AccountProfile,
      children: [{
        path: 'settings',
        name: 'account-profile-settings',
        component: AccountProfileSettings
      },{
        path: 'fit-and-style',
        name: 'account-profile-fit-and-style',
        component: AccountProfileFitAndStyle
      },{
        path: 'billing',
        name: 'account-profile-billing',
        component: AccountProfileBilling
      }]
    }]
  },
  {
    path: '/trip/:id',
    name: 'trip',
    component: Wizard
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    children: [{
      path: 'dashboard',
      name: 'admin-dashboard',
      component: AdminDashboard
    }, {
      path: 'trip/:trip_id',
      name: 'admin-trip',
      component: AdminTrip
    },{
      path: 'inventory',
      name: 'admin-inventory',
      component: AdminInventory
    },{
      path: 'users',
      name: 'admin-users',
      component: AdminUsers
    }]
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    meta: { noauth: true }
  },
  {
    path: '/auth/forgot',
    name: 'auth-forgot',
    component: AuthForgot,
    meta: { noauth: true }
  },
  {
    path: '/auth/register',
    name: 'auth-register',
    component: AuthRegister,
    meta: { noauth: true }
  },
  {
    path: '/auth/register/:provider',
    name: 'auth-register-provider',
    component: AuthRegister,
    meta: { noauth: true }
  },
  {
    path: '/auth/reset/:token',
    name: 'auth-reset',
    component: AuthReset,
    meta: { noauth: true }
  },
  {
    path: '/auth/oauth/:provider',
    name: 'auth-oauth',
    component: AuthOauth,
    meta: { noauth: true }
  },
  {
    path: '/auth/verify/:token',
    name: 'auth-verify',
    component: AuthVerify,
    meta: { noauth: true }
  },
  {
    path: '*',
    redirect: '/account'
  }
];

const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE,
  routes
});

export default router;
